import React, { useContext, useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
import { AuthContext } from "../../context/AuthContextProvider.js";
import * as Yup from "yup";
import {
  userProfileUpdate,
  useGetUserProfile,
  useGetWorkspaces,
} from "../../api/settings";
import { toast } from "sonner";
import { Helmet } from "react-helmet";

import { useForm, Controller } from "react-hook-form";
import { RequireAuth } from "../../RequireAuth.jsx";
import {
  Autocomplete,
  TextField,
  Chip,
  Avatar,
  Button,
  CircularProgress,
  Grid,
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from "@mui/material";

// MUI Date Picker
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

// date-fns for local date formatting
import { format as formatDate } from "date-fns";
import { enGB } from "date-fns/locale";
import ImageCropperDialog from "../../components/ImageCropper.jsx";
import ImageUploader from "../../components/Reusables/ImageControls/ImageUploader.jsx";
import FormTextField from "../../components/Reusables/FormControls/FormTextFeilds.jsx";
import FormDatePicker from "../../components/Reusables/FormControls/FormDatePicker.jsx";
import FormSelect from "../../components/Reusables/FormControls/FormSelect.jsx";
import FormQualifications from "../../components/Reusables/FormControls/FormQualifications.jsx";
import FormCountryPicker from "../../components/Reusables/FormControls/FormCountryPicker.jsx";
import StickySaveButton from "../../components/Reusables/FormControls/FormSaveButton.jsx";
import proffesionTypes from "../../data/proffesionTypes.json";
import qualification from "../../data/qualification.json";

import { parse, isValid } from "date-fns";
import { formatText } from "../../components/Reusables/TextValidation/SanitizeText.js";
import {
  sanitizePhoneNumber,
  getPhoneNumberLimit,
} from "../../utils/phoneNumber";

const Profile = () => {
  const { user, all_centres, open } = useContext(AuthContext);
  const scrollContainerRef = useRef(null);

  const { workspaces } = useGetWorkspaces({});
  const { userProfile: data, refetch } = useGetUserProfile({});

  const defaultValues = {
    first_name: "",
    middle_name: "",
    last_name: "",
    phoneNumber: "",
    email: "",
    gender: "",
    dob: null,
    designation: "",
    user_type: "",
    qualifications: data?.qualifications
      ? data?.qualifications.map((q) => q.trim())
      : [],
    medical_license_number: data?.medicalLicenseNumber || "",
    profession: data?.profession || "",
    doctorSignature: "",
    countryCode: "+91",
    virtualId: "",
  };

  const {
    control,
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { isDirty, dirtyFields },
  } = useForm({
    defaultValues,
    mode: "onChange",
  });

  const watchedValues = watch();
  const [isChanged, setIsChanged] = useState(false);
  const [originalData, setOriginalData] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [signatureFile, setSignatureFile] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [isEditingSignature, setIsEditingSignature] = useState(false);
  const [cropOpen, setCropOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const logoInputRef = useRef(null);
  const signatureInputRef = useRef(null);

  useEffect(() => { }, [watchedValues]);
  const isInitialLoad = useRef(true);

  const data2 = qualification.map((item) => ({
    label: item,
    value: item,
  }));

  // detect changes
  useEffect(() => {
    if (!originalData || !watchedValues) return;

    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }

    let changed = Object.keys(originalData).some((key) => {
      if (key === "logo" || key === "doctorSignature") return false;

      if (key === "dob") {
        const o =
          originalData.dob instanceof Date && isValid(originalData.dob)
            ? formatDate(originalData.dob, "dd-MM-yyyy")
            : null;

        const w =
          watchedValues.dob instanceof Date && isValid(watchedValues.dob)
            ? formatDate(watchedValues.dob, "dd-MM-yyyy")
            : null;

        return o !== w;
      }

      if (key === "qualifications") {
        return (
          JSON.stringify([...(watchedValues[key] || [])].sort()) !==
          JSON.stringify([...(originalData[key] || [])].sort())
        );
      }

      return watchedValues[key] !== originalData[key];
    });

    if (logoFile || signatureFile) {
      changed = true;
    }

    setIsChanged(changed);
  }, [watchedValues, originalData, logoFile, signatureFile]);

  // reset form when data is loaded (but not when editing signature)
  // useEffect(() => {
  //   if (data && !isEditingSignature) {
  //     if (!logoPreview) {
  //       setLogoPreview(data?.logo || null);
  //     }

  //     if (!signaturePreview && data?.signature) {
  //       setSignaturePreview(data.signature);
  //       setValue("doctorSignature", data.signature, { shouldDirty: false });
  //     }

  //     // data.dateOfBirth is "YYYY-MM-DD", so we can safely use new Date()
  //     let dobValue = null;

  //     if (data?.dateOfBirth) {
  //       const parsed = parse(data.dateOfBirth, "dd-MM-yyyy", new Date());
  //       if (isValid(parsed)) {
  //         dobValue = parsed;
  //       }
  //     }

  //     const formData = {
  //       first_name: data?.firstName || "",
  //       middle_name: data?.middleName || "",
  //       last_name: data?.lastName || "",
  //       phoneNumber: data?.phoneNo || "",
  //       email: data?.email || "",
  //       gender: data?.gender || "",
  //       dob: dobValue,
  //       designation: data?.designation || "",
  //       user_type: data?.userType || "",
  //       qualifications: data?.qualifications || [],
  //       medical_license_number: data?.medicalLicenseNumber || "",
  //       profession: data?.profession || "",
  //       doctorSignature: data?.signature || "",
  //       countryCode: data?.countryCode || "+91",
  //     };
  //     isInitialLoad.current = true;
  //     setOriginalData(formData);
  //     reset(formData);
  //     // setSignatureFile(null);
  //   }
  // }, [data, reset, isEditingSignature]);
  const hasInitializedRef = useRef(false);

  // useEffect(() => {
  //   if (!data || hasInitializedRef.current) return;

  //   let dobValue = null;

  //   if (data?.dateOfBirth) {
  //     const parsed = parse(data.dateOfBirth, "dd-MM-yyyy", new Date());
  //     if (isValid(parsed)) {
  //       dobValue = parsed;
  //     }
  //   }

  //   const formData = {
  //     first_name: data?.firstName || "",
  //     middle_name: data?.middleName || "",
  //     last_name: data?.lastName || "",
  //     phoneNumber: data?.phoneNo || "",
  //     email: data?.email || "",
  //     gender: data?.gender || "",
  //     dob: dobValue,
  //     designation: data?.designation || "",
  //     user_type: data?.userType || "",
  //     qualifications: data?.qualifications || [],
  //     medical_license_number: data?.medicalLicenseNumber || "",
  //     profession: data?.profession || "",
  //     doctorSignature: data?.signature || "",
  //     countryCode: data?.countryCode || "+91",
  //   };

  //   setOriginalData(formData);
  //   reset(formData);

  //   if (data?.logo) setLogoPreview(data.logo);
  //   if (data?.signature) setSignaturePreview(data.signature);

  //   hasInitializedRef.current = true;
  // }, [data]);

  useEffect(() => {
    if (!data) return;

    let dobValue = null;

    if (data?.dateOfBirth) {
      const parsed = parse(data.dateOfBirth, "dd-MM-yyyy", new Date());
      if (isValid(parsed)) {
        dobValue = parsed;
      }
    }

    const formData = {
      first_name: data?.firstName || "",
      middle_name: data?.middleName || "",
      last_name: data?.lastName || "",
      phoneNumber: data?.phoneNo || "",
      email: data?.email || "",
      gender: data?.gender || "",
      dob: dobValue,
      designation: data?.designation || "",
      user_type: data?.userType || "",
      qualifications: data?.qualifications || [],
      medical_license_number: data?.medicalLicenseNumber || "",
      profession: data?.profession || "",
      doctorSignature: data?.signature || "",
      countryCode: data?.countryCode || "+91",
      virtualId: data?.virtualId || "",
    };

    setOriginalData(formData);
    reset(formData);

    if (data?.logo) setLogoPreview(data.logo);
    if (data?.signature) setSignaturePreview(data.signature);
  }, [data]);
  useEffect(() => { }, [signaturePreview]);

  const [buttonLoading, setButtonLoading] = useState(false);

  const sanitizePhoneNumber = (value) => {
    if (!value) return "";

    return String(value).replace(/\D/g, "");
  };

  const getPhoneNumberLimit = (countryCode) => {
    const limits = {
      "+91": 10,
      "+1": 10,
      "+44": 10,
      "+61": 9,
      "+971": 9,
    };

    return limits[countryCode] || 10;
  };

  const ProfileSchema = Yup.object()
    .shape({
      first_name: Yup.string()
        .required("First Name is required"),
      last_name: Yup.string()
        .trim()
        .max(150, "Last Name cannot exceed 150 characters"),
      designation: Yup.string()
        .trim()
        .max(150, "Designation cannot exceed 150 characters"),

      phoneNumber: Yup.string().test(
        "phone-or-virtual",
        function (value) {
          const phoneNumber = sanitizePhoneNumber(value);
          const virtualId = this.parent?.virtualId;
          const countryCode = this.parent?.countryCode || "+91";

          // Virtual ID profile → phone is not required
          if (!phoneNumber && virtualId) {
            return true;
          }

          // Normal profile → phone is required
          if (!phoneNumber && !virtualId) {
            return this.createError({
              message: "Phone Number is required",
            });
          }

          const limit = getPhoneNumberLimit(countryCode);

          if (!/^\d+$/.test(phoneNumber)) {
            return this.createError({
              message: "Phone number must contain only digits.",
            });
          }

          if (phoneNumber.length !== limit) {
            return this.createError({
              message: `Enter a valid ${limit}-digit phone number.`,
            });
          }

          return true;
        },
      ),
      email: Yup.string()
        .trim()
        .max(150, "Email cannot exceed 150 characters")
        .test(
          "valid-email",
          "Enter a valid email address",
          (value) => {
            if (!value) return true; // Email is optional
            return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
          }
        )
        .test(
          "no-consecutive-dots",
          "Enter a valid email address",
          (value) => {
            if (!value) return true;
            return !value.includes("..");
          }
        )
        .test(
          "no-invalid-dot-position",
          "Enter a valid email address",
          (value) => {
            if (!value) return true;

            return (
              !value.startsWith(".") &&
              !value.endsWith(".") &&
              !value.includes("@.") &&
              !value.includes(".@")
            );
          }
        ),

      virtualId: Yup.string(),

      gender: Yup.string().required("Gender is required"),
      profession: Yup.string().required("Profession is required"),
      dob: Yup.date()
        .typeError("Please enter a valid date")
        .required("Date of Birth is required")
        .max(new Date(), "Date of Birth cannot be in the future")
        .test("valid-year", "Please enter a valid Year", function (value) {
          if (!value || !isValid(value)) return false;

          const year = value.getFullYear();
          const currentYear = new Date().getFullYear();

          return year >= 1900 && year <= currentYear;
        }),
    });


  const [errors, setErrors] = useState({});

  const handleLogoFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    e.target.value = "";

    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setCropOpen(true);
    };
    reader.readAsDataURL(file);
  };
  const handleCroppedLogo = (file) => {
    if (logoPreview) URL.revokeObjectURL(logoPreview);

    const previewUrl = URL.createObjectURL(file);
    setLogoPreview(previewUrl);
    setLogoFile(file);

    // mark form dirty
    setValue("logo", file, { shouldDirty: true });

    setCropOpen(false);
  };

  // useEffect(() => {
  //   // if (signatureFile) {
  //   //   setValue("doctorSignature", signatureFile, { shouldDirty: true });
  //   // } else {
  //   //   setValue("doctorSignature", null, { shouldDirty: true });
  //   // }
  //   if (signatureFile) {
  //     setSignaturePreview(URL.createObjectURL(signatureFile));
  //   }

  //   if (logoFile) {
  //     setLogoPreview(URL.createObjectURL(logoFile));
  //   }
  // }, [signatureFile, setValue]);

  useEffect(() => {
    let signatureUrl;
    let logoUrl;

    if (signatureFile) {
      signatureUrl = URL.createObjectURL(signatureFile);
      setSignaturePreview(signatureUrl);
    }

    if (logoFile) {
      logoUrl = URL.createObjectURL(logoFile);
      setLogoPreview(logoUrl);
    }

    return () => {
      if (signatureUrl) URL.revokeObjectURL(signatureUrl);
      if (logoUrl) URL.revokeObjectURL(logoUrl);
    };
  }, [signatureFile, logoFile]);
  const handleSignatureFileChange = (e) => {
    setIsEditingSignature(true);

    const file = e.target.files?.[0];
    if (!file) {
      setIsEditingSignature(false);
      return;
    }

    if (signaturePreview) URL.revokeObjectURL(signaturePreview);
    const previewUrl = URL.createObjectURL(file);
    setSignaturePreview(previewUrl);
    setSignatureFile(file);
    setValue("doctorSignature", file, { shouldDirty: true });

    // setTimeout(() => {
    //   setIsEditingSignature(false);
    // }, 5000);
  };

  const onSubmit = async (formValues) => {
    try {
      const valuesForValidation = {
        ...formValues,
        phoneNumber: formValues.phoneNumber || data?.phoneNo || "",
        virtualId: formValues.virtualId || data?.virtualId || "",
        countryCode: formValues.countryCode || data?.countryCode || "+91",
      };

      await ProfileSchema.validate(valuesForValidation, {
        abortEarly: false,
      });

      setErrors({});

      //  Helper to clean strings safely
      const cleanValue = (val) =>
        typeof val === "string" ? formatText(val) : val;

      // Format DOB
      let formattedDate = null;
      if (formValues.dob) {
        if (formValues.dob instanceof Date && !isNaN(formValues.dob)) {
          formattedDate = formatDate(formValues.dob, "dd-MM-yyyy");
        } else if (typeof formValues.dob === "string") {
          const parsed = new Date(formValues.dob);
          if (!isNaN(parsed)) {
            formattedDate = formatDate(parsed, "dd-MM-yyyy");
          }
        }
      }

      //  Handle qualifications
      const qualificationsArray = Array.isArray(formValues.qualifications)
        ? formValues.qualifications
        : formValues.qualifications
          ? formValues.qualifications.split(",").map((q) => q.trim())
          : [];

      const cleanedQualifications = qualificationsArray.map((q) =>
        formatText(q),
      );

      //  Final payload
      const args = {
        gender: cleanValue(formValues.gender),
        dateOfBirth: formattedDate,
        designation: cleanValue(formValues.designation),
        firstName: cleanValue(formValues.first_name),
        lastName: cleanValue(formValues.last_name),
        email: cleanValue(formValues.email),
        profession: cleanValue(formValues.profession),
        qualifications: cleanedQualifications,
        medical_license_number: cleanValue(formValues.medical_license_number),
      };

      const formData = new FormData();
      formData.append("profileDetails", JSON.stringify(args));

      if (logoFile) {
        formData.append("file", logoFile);
      }

      if (signatureFile) {
        formData.append("doctorSignature", signatureFile);
      }

      setButtonLoading(true);

      const response = await userProfileUpdate(formData);
      hasInitializedRef.current = false;

      if (response.success) {
        toast.success("Profile updated successfully");
        await refetch();
        setIsChanged(false);
        setIsEditingSignature(false);

        const currentValues = watch();
        setOriginalData(currentValues);
      } else {
        toast.error(response.message || "Failed to update profile");
      }
    } catch (err) {
      console.error("Form submission error:", err);

      const formattedErrors = {};

      if (err.inner) {
        err.inner.forEach((e) => {
          if (e.path) {
            formattedErrors[e.path] = {
              message: e.message,
            };
          }
        });
      } else {
        formattedErrors.general = {
          message: err.message || "An error occurred",
        };
      }
      setErrors(formattedErrors);
      toast.error(
        Object.values(formattedErrors)[0]?.message ||
        "Please fix the highlighted errors"
      );
    } finally {
      setButtonLoading(false);
    }
  };

  const DropdownIcon = (props) => (
    <Icon
      icon="eva:arrow-ios-downward-fill"
      width="20"
      height="20"
      {...props}
    />
  );

  const textFieldSx = {
    "& .MuiOutlinedInput-root": {
      height: 52,
      borderRadius: "12px",
      backgroundColor: "var(--app-surface)",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--app-border)",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "var(--app-text-muted)",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#5751E9",
    },
    "& .MuiInputLabel-root": {
      fontSize: "14px",
      fontWeight: 500,
      color: "#111",
    },
    "& .MuiFormHelperText-root": {
      marginLeft: 0,
      fontSize: "12px",
    },
  };

  const PROFESSION_OPTIONS = proffesionTypes.map((item) => ({
    label: item,
    value: item,
  }));

  const getUserRoleLabel = (user) => {
    if (!user?.userType) return "Another";

    switch (user.userType) {
      case "b2b":
        return "Organisation Admin (Owner)";
      case "b2b-member":
        return `Member (${user?.designation || user?.profession || "-"})`;
      case "b2b-admin":
        return `Centre Admin (${user?.designation || user?.profession || "-"})`;
      case "b2b-doctor":
        return `Doctor (${user?.designation || user?.profession || "-"})`;
      case "b2b-viewer":
        return "Viewer";
      default:
        return "Another";
    }
  };
  const identifier = data?.virtualId || data?.phoneNo;
  const isVirtualUser = !!(user?.virtualId || data?.virtualId);

  return (
    <>
      <Helmet>
        <title>Spandan - Settings</title>
      </Helmet>
      <Box className="main-wrappers">
        <Box
          className="page-wrapper"
          sx={{
            pb: "90px",
            pt: "75px",
            maxHeight: "100vh",
            overflowY: "auto",
            fontFamily: "Figtree",
          }}
          ref={scrollContainerRef}
        >
          <Box className="content">
            <h4>
              <strong> My Profile </strong>
            </h4>

            <Container
              maxWidth={false}
              sx={{
                mt: 3,
                mb: 6,
                width: "100%",
                p: "0px !important",
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  backgroundColor: "var(--app-surface)",
                  borderRadius: "18px",
                  px: { xs: 2, sm: 3, md: 4 },
                  py: { xs: 2, sm: 3 },
                }}
              >
                <form onSubmit={handleSubmit(onSubmit)}>
                  {/* ================= PROFILE HEADER ================= */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mb: 4,
                    }}
                  >
                    {/* Avatar */}
                    <Box sx={{ position: "relative", width: 75, height: 75 }}>
                      <input
                        type="file"
                        accept="image/*"
                        ref={logoInputRef}
                        hidden
                        onChange={handleLogoFileChange}
                      />

                      <Avatar
                        src={logoPreview || undefined}
                        sx={{
                          width: 75,
                          height: 75,
                          bgcolor: "#F4F5FF",
                          border: "1px solid var(--app-border)",
                          cursor: "pointer",
                        }}
                        onClick={() => logoInputRef.current?.click()}
                      />

                      <Box
                        onClick={() => logoInputRef.current?.click()}
                        sx={{
                          position: "absolute",
                          bottom: 0,
                          right: 0,
                          width: 26,
                          height: 26,
                          borderRadius: "50%",
                          bgcolor: "#5751E9",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        <Icon
                          icon="mdi:pencil"
                          width="16"
                          height="16"
                          color="#fff"
                        />
                      </Box>
                    </Box>

                    {/* Name */}
                    <Box>
                      <Typography
                        variant="h6"
                        fontWeight={600}
                        sx={{
                          fontFamily: "figtree",
                          fontSize: "20px",
                          fontWeight: 700,
                        }}
                      >
                        {originalData?.first_name} {originalData?.last_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                          fontFamily: "figtree",
                          fontSize: "15px",
                          fontWeight: 500,
                        }}
                      >
                        {getUserRoleLabel(user)}
                      </Typography>
                    </Box>
                  </Box>

                  {/* ================= FORM FLEX WRAPPER ================= */}
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "16px",
                    }}
                  >
                    {user.userType === "b2b" && (
                      <>
                        <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                          <FormTextField
                            label="First Name"
                            name="first_name"
                            register={register}
                            errors={errors}
                            required
                            limit={150}
                          />
                        </Box>

                        <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                          <FormTextField
                            label="Last Name"
                            name="last_name"
                            register={register}
                            errors={errors}
                            limit={150}
                          />
                        </Box>

                        <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 32%" } }}>
                          <FormTextField
                            label="Designation"
                            name="designation"
                            register={register}
                            errors={errors}
                            limit={150}
                          />
                        </Box>
                      </>
                    )}
                    <Box
                      sx={{
                        flex: { xs: "1 1 100%", md: "1 1 calc(36% - 8px)" },
                      }}
                    >
                      <Typography
                        fontSize={14}
                        fontWeight={500}
                        mb="6px"
                        sx={{
                          fontFamily: "figtree",
                          color: "var(--app-text-muted)",
                        }}
                      >
                        {isVirtualUser ? "User ID" : "Contact Number"}
                        <span style={{ color: "#d32f2f" }}>*</span>
                      </Typography>

                      {!isVirtualUser ? (
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Box sx={{ width: "80px" }}>
                            <FormCountryPicker
                              name="countryCode"
                              control={control}
                              disabled
                            />
                          </Box>

                          <Box sx={{ flex: 1 }}>
                            <FormTextField
                              name="phoneNumber"
                              register={register}
                              errors={errors}
                              disabled
                            />
                          </Box>
                        </Box>
                      ) : (
                        <FormTextField
                          name="virtualId"
                          register={register}
                          errors={errors}
                          disabled
                        />
                      )}
                    </Box>

                    <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 35%" } }}>
                      <FormTextField
                        label="Email Address"
                        name="email"
                        register={register}
                        errors={errors}
                        limit={150}
                      />
                    </Box>

                    <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
                      <FormDatePicker
                        label="Date of Birth"
                        name="dob"
                        control={control}
                        errors={errors}
                        required
                      />
                    </Box>

                    <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
                      <FormSelect
                        label="Gender"
                        name="gender"
                        control={control}
                        errors={errors}
                        required
                        options={[
                          { label: "Select Gender", value: "" },
                          { label: "Female", value: "Female" },
                          { label: "Male", value: "Male" },
                          { label: "Others", value: "Others" },
                        ]}
                      />
                    </Box>

                    <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
                      <FormSelect
                        label="Profession"
                        name="profession"
                        control={control}
                        errors={errors}
                        required
                        options={PROFESSION_OPTIONS}
                        searchable
                      />
                    </Box>

                    <Box sx={{ flex: { xs: "1 1 100%", md: "1 1 49%" } }}>
                      <FormTextField
                        label="Medical License Number (if applicable)"
                        name="medical_license_number"
                        register={register}
                        errors={errors}
                      />
                    </Box>

                    <Box sx={{ flex: "1 1 100%" }}>
                      <FormQualifications
                        label="Qualifications"
                        name="qualifications"
                        control={control}
                        errors={errors}
                        options={data2}
                      />
                    </Box>
                    {user.userType === "b2b-doctor" && (
                      <Box sx={{ flex: "1 1 100%" }}>
                        <ImageUploader
                          label="Upload Signature"
                          file={signatureFile}
                          setFile={setSignatureFile}
                          preview={signaturePreview}
                          setPreview={setSignaturePreview}
                          uploader="signature"
                        />
                      </Box>
                    )}
                  </Box>

                  <StickySaveButton
                    label="Save Details"
                    loading={buttonLoading}
                    disabled={!isChanged}
                    open={open}
                  />
                </form>
              </Paper>
            </Container>

            {user?.userType !== "b2b" && (
              <>
                <Box
                  className="card2 pt-20"
                  sx={{
                    p: "20px",
                    borderRadius: 2,
                    bgcolor: "var(--app-surface)", // whole box white
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    mb={2}
                    fontSize={20}
                    color="var(--app-text)"
                  >
                    Your Workspaces
                  </Typography>

                  {workspaces.length > 0 && (
                    <TableContainer
                      sx={{
                        maxHeight: 420,
                        overflowY: "auto",
                        overflowX: "auto",
                        borderRadius: "16px",
                        background: "var(--app-surface)",

                        "&::-webkit-scrollbar": {
                          width: 6,
                          height: 6,
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: "var(--app-surface)",
                          borderRadius: 10,
                        },
                      }}
                    >
                      <Table
                        stickyHeader
                        sx={{
                          minWidth: 700,
                          borderCollapse: "separate",
                          borderSpacing: { xs: "0px 8px", md: "0px 12px" },

                          "& th": {
                            borderBottom: "none",
                            fontWeight: 800,
                            fontSize: { xs: "11px", md: "15px" },
                            color: "#A3A3A3",
                            py: { xs: 1.5, md: 2 },
                            backgroundColor: "var(--app-surface)",
                          },

                          "& td": {
                            borderBottom: "none",
                            fontSize: { xs: "13px", md: "15px" },
                            py: { xs: 1.5, md: 1.8 },
                            px: { xs: 1.2, md: 2 },
                            color: "var(--app-text)",
                            backgroundColor: "var(--app-surface-2)", // row card color
                          },
                        }}
                      >
                        {/* HEADER */}
                        <TableHead>
                          <TableRow>
                            {["NAME", "MOBILE NUMBER", "TYPE", "ADDRESS"].map(
                              (head) => (
                                <TableCell key={head} align="left">
                                  <Typography
                                    sx={{
                                      fontSize: { xs: "11px", md: "15px" },
                                      fontWeight: 800,
                                      fontFamily: "Figtree",
                                    }}
                                  >
                                    {head}
                                  </Typography>
                                </TableCell>
                              ),
                            )}
                          </TableRow>
                        </TableHead>

                        {/* ROWS */}
                        <TableBody>
                          {workspaces.map((workspace, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                "& > *:first-of-type": {
                                  borderTopLeftRadius: "12px",
                                  borderBottomLeftRadius: "12px",
                                },
                                "& > *:last-of-type": {
                                  borderTopRightRadius: "12px",
                                  borderBottomRightRadius: "12px",
                                },
                              }}
                            >
                              <TableCell>
                                <Box display="flex" alignItems="center">
                                  <Avatar
                                    src={workspace.business_logo || undefined}
                                    sx={{ width: 36, height: 36 }}
                                  />
                                  <Box ml={2} fontWeight={500}>
                                    {workspace.business_name || "--"}
                                  </Box>
                                </Box>
                              </TableCell>

                              <TableCell>
                                {workspace.phone_no
                                  ? `${workspace.country_code ?? ""} ${workspace.phone_no}`
                                  : "-"}
                              </TableCell>

                              <TableCell>{workspace.type || "--"}</TableCell>

                              <TableCell>
                                {workspace.address?.area || "--"},{" "}
                                {workspace.address?.city || "--"}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Box>

                <Typography
                  variant="body2"
                  color="var(--app-text)"
                  fontSize={15}
                  fontWeight={500}
                >
                  For any queries, contact your administrator at{" "}
                  <Typography
                    component="span"
                    fontWeight={700}
                    color="var(--app-text)"
                    fontSize={15}
                  >
                    {user.supportNumber}
                  </Typography>
                </Typography>
              </>
            )}
            {user?.userType === "b2b" && (
              <Typography
                variant="body2"
                color="var(--app-text)"
                fontSize={15}
                fontWeight={500}
              >
                For any queries, contact your administrator at{" "}
                <Typography
                  component="span"
                  fontWeight={700}
                  color="var(--app-text)"
                  fontSize={15}
                >
                  {user.supportNumber}
                </Typography>
              </Typography>
            )}
          </Box>
        </Box>
      </Box>

      <ImageCropperDialog
        open={cropOpen}
        imageSrc={imageSrc}
        aspect={1}
        onClose={() => setCropOpen(false)}
        onSave={handleCroppedLogo}
      />
    </>
  );
};

const CalendarIcon = () => <Icon icon="uiw:date" width="20" height="20" />;
export default Profile;